<!--show_legend: bool-->
<!--show_question: bool-->
<!--show_percentage: bool-->
<!--horizontal_display: bool-->
<!--vertical_display: bool-->
<!--legend_colors: list of colors-->
<!--section: list of sections-->
  <!--questions: list of questions-->
    <!--answers: list of answers-->
      <!--text: string-->
      <!--color: string-->
      <!--percent: integer-->
{{#each sections}}
<div class="survey-results">
    {{#if ../show_legend}}
    <div class="legend text-center">
        {{#each questions.[0].answers}}
          <div class="legend-key legend-key-{{@index}}">
              <div class="legend-key-description"><div class="description"> {{t text}}</div></div>
          </div>
        {{/each}}
    </div>
    {{/if}}
    {{#each questions}}
    <div class="question-section">
        {{#if ../../vertical_display}}
        <div class="">
            {{#each answers}}
            <div class="question-text">
                <div class="survey-results-bar" style="height: {{percent}}%;">
                    <div class="text-center">{{percent}}%</div>
                </div>
            </div>
            {{/each}}
        </div>
        {{/if}}

        {{#if ../../horizontal_display}}
        <div class="region-sm-row region-auto-fit survey-results-questions">
            <div class="regions">
                <div class="region region0 survey-results-question">
                    {{text}}
                </div>
                <div class="region region1">
                  <div class="survey-results-bar-wrapper">
                    {{#each answers}}
                    <div class="survey-results-bar" style="background-color: {{color}}; width:{{percent}}%;">
                        {{#if ../../../show_percentage}}
                            <span>{{percent}}%</span>
                        {{/if}}
                    </div>
                    {{/each}}
                  </div>
              </div>
            </div>
        </div>
        {{/if}}
    </div>
    {{/each}}
</div>
{{/each}}
